import * as Yup from 'yup'

import { ChangePasswordFieldsNames, LoginFieldsNames, ResetPasswordFieldsNames } from '@/models/auth'

import { PASSWORD_REGEX } from './utils'

// ============================================================================
// AUTHENTICATION SCHEMAS
// ============================================================================

export const loginSchema = Yup.object().shape({
  [LoginFieldsNames.EMAIL]: Yup.string().email().required(),
  [LoginFieldsNames.PASSWORD]: Yup.string().required(),
})

export const resetPasswordSchema = Yup.object().shape({
  [ResetPasswordFieldsNames.EMAIL]: Yup.string().email().required(),
})

export const changePasswordSchema = Yup.object().shape({
  [ChangePasswordFieldsNames.NEW_PASSWORD]: Yup.string().required().matches(PASSWORD_REGEX, 'validation.password'),
  [ChangePasswordFieldsNames.CONFIRM_PASSWORD]: Yup.string()
    .required()
    .oneOf([Yup.ref(ChangePasswordFieldsNames.NEW_PASSWORD)], 'validation.password_match'),
})
